// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { showSnackBar } from "../../snackbar/actions"
import { executor, Init, timesheetFieldService } from "../../../app/rpc"
import {
  ListRecentTimesheetFieldOptionsRequestSchema,
  ListRecentTimesheetFieldOptionsResponse,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type ListRecentTimesheetFieldOptionsRpc = (request: Init<typeof ListRecentTimesheetFieldOptionsRequestSchema>) => Observable<ListRecentTimesheetFieldOptionsResponse>

export const listRecentTimesheetFieldOptions = (listRecentTimesheetFieldOptionsRpc: ListRecentTimesheetFieldOptionsRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.listRecentTimesheetFieldOptions.match),
      mergeMap((action) => listRecentTimesheetFieldOptionsRpc(action.payload)
        .pipe(
          map(response => ({ options: response.timesheetFieldOptions })),
          map(Slice.setRecentTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_list_recent_timesheet_field_options_failed",
              message: "Failed to load recent timesheet field options. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )),
    )

const listRecentTimesheetFieldOptionsRpc = (request: Init<typeof ListRecentTimesheetFieldOptionsRequestSchema>): Observable<ListRecentTimesheetFieldOptionsResponse> =>
  executor(() => timesheetFieldService.listRecentTimesheetFieldOptions(create(ListRecentTimesheetFieldOptionsRequestSchema, request)))

export default listRecentTimesheetFieldOptions(listRecentTimesheetFieldOptionsRpc)
